import React from "react";
import { useChannelIOApi } from "react-channel-plugin";
import { Button } from "../../Components/StyledComponents";
import "./ReqHotelOrder.scss";

const ReqHotelOrder = () => {
  const { showMessenger } = useChannelIOApi();

  return (
    <div className="req-order">
      <p className="text">호텔 객실도 QR로 간편주문</p>
      <p className="title">시럽프렌즈 호텔 오더</p>
      <Button
        variant="sub"
        style={{ width: 114, marginTop: 64 }}
        onClick={showMessenger}
      >
        상담 문의하기
      </Button>
    </div>
  );
};

export default ReqHotelOrder;
